export const defaultIcon = require("../assets/avatar-chat1.png");
export const back = require("../assets/leftArrow1.png");
